import { Gate, useAuth } from '../../global/contexts/auth/auth';
import KpiDashboard from '../../features/kpis/layouts/dashboard';

import '../styles/dashboard.css';

// TSS vite/01 §"Pages are thin". Home: panel de informes (KPIs) para quien tenga
// `kpis:read`; bienvenida de marca como fallback para el resto.
export default function DashboardPage() {
    const { user } = useAuth();
    const name = user?.name || user?.username || '';

    return (
        <Gate
            domain="kpis"
            action="read"
            fallback={
                <div className="dashboard">
                    <section className="dashboard__hero">
                        <span className="dashboard__eyebrow">Panel</span>
                        <h1 className="dashboard__title">Hola{name ? `, ${name}` : ''}.</h1>
                        <p className="dashboard__subtitle">
                            Núcleo operativo de la genética bovina. Elegí un módulo en el menú para empezar.
                        </p>
                    </section>
                </div>
            }
        >
            <KpiDashboard />
        </Gate>
    );
}
